
<!--
 * @Description: 教职工详情 专业技术职务
 * @Author: 张天伟
 * @Date: 2023-03-08 11:59:14
 * @LastEditors: PF
 * @LastEditTime: 2023-03-10 17:57:31
-->
<template>
  <div>
    <el-descriptions class="descript-box" v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="任职资格名称" label-align="right" align="left" width="120px" span="2">{{item.rzzgmc}}</el-descriptions-item>
      <el-descriptions-item label="取得资格途径" label-align="right" align="left" width="120px" span="2">{{item.qdzgtjbt}}</el-descriptions-item>
      <el-descriptions-item label="评审单位" label-align="right" align="left" width="120px" span="2">{{item.psdw}}</el-descriptions-item>
      <el-descriptions-item label="评定日期" label-align="right" align="left" width="120px" span="2">{{item.pdrq}}</el-descriptions-item>
      <el-descriptions-item label="聘任职务" label-align="right" align="left" width="120px" span="2">{{item.przw}}</el-descriptions-item>
      <el-descriptions-item label="聘任单位" label-align="right" align="left" width="120px" span="2">{{item.prdw}}</el-descriptions-item>
      <el-descriptions-item label="聘任起始日期" label-align="right" align="left" width="120px" span="2">{{item.prqsrq}}</el-descriptions-item>
      <el-descriptions-item label="聘任终止日期" label-align="right" align="left" width="120px" span="2">{{item.przzrq}}</el-descriptions-item>
      <el-descriptions-item label="聘任情况" label-align="right" align="left" width="120px" span="2">{{item.prqkbt}}</el-descriptions-item>
      <el-descriptions-item label="解聘日期" label-align="right" align="left" width="120px" span="2">{{item.jprq}}</el-descriptions-item>
      <el-descriptions-item label="解聘原因" label-align="right" align="left" width="120px" span="4">{{item.jpyy}}</el-descriptions-item>
      <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = {
        url: '/api/v2/renliziyuan/jiaozhigongzhuanyejishuzhiwu/list',
        data: { id: props.row.id, order: 'gh', sort: 'asc' }
      }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
